import { BillingPanel } from '@orisini/ui/components/billing-panel'
import { useProductAuth } from '@orisini/ui/context/AuthContext'

/**
 * Langganan Orisini — dibeli langsung dari sini, tanpa pindah ke orisini.com.
 *
 * Paketnya satu untuk seluruh Orisini, jadi panel ini identik dengan yang di
 * orisini.com/billing. Yang tetap milik orisini: uangnya, tabel order, dan
 * verifikasi pembayaran — Worker produk ini cuma meneruskan.
 */
export default function BillingPage() {
  const { me } = useProductAuth()

  return (
    <BillingPanel
      planCode={me?.plan.code}
      planName={me?.plan.name}
      periodEnd={me?.plan.periodEnd}
      active={me?.plan.active}
      cancelAtPeriodEnd={me?.plan.cancelAtPeriodEnd}
    />
  )
}
